// extracted by mini-css-extract-plugin
export default {"section1":"Index_section1__PAQRn","wrapper":"Index_wrapper__vOlYc","textbox":"Index_textbox__AKTrZ","section2":"Index_section2__SOkV0","section3":"Index_section3__pTaMS"};